import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  InputAdornment,
  Stack,
  Tooltip
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import { useIntl } from 'react-intl';
import FunctionsIcon from '@mui/icons-material/Functions';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';

function ExpandableTextArea({
  field,
  error,
  helperText,
  clearField,
  label,
  minRows = 6,
  maxRows = 12,
  freemarker = false
}) {
  const { formatMessage: msg } = useIntl();
  const [openModal, setOpenModal] = useState(false);

  const handleExpandClick = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <MDInput
        {...field}
        label={label}
        variant="filled"
        fullWidth
        size="small"
        sx={{ flex: 1 }}
        multiline
        minRows={minRows}
        maxRows={maxRows}
        error={!!error}
        helperText={helperText}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Stack display="flex" direction="column">
                {freemarker ? (
                  <InputAdornment position="end">
                    <FunctionsIcon />
                  </InputAdornment>
                ) : null}

                <Tooltip title={msg({ id: 'tooltip.clear' })}>
                  <IconButton onClick={() => clearField('content')} sx={{ paddingBottom: 0 }}>
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title={msg({ id: 'tooltip.textarea.expand' })}>
                  <IconButton onClick={handleExpandClick} color="primary" sx={{ paddingTop: 0 }}>
                    <AspectRatioIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            </InputAdornment>
          )
        }}
      />
      <Dialog open={openModal} onClose={handleModalClose} maxWidth="lg" fullWidth scroll="paper">
        <DialogContent sx={{ pb: 0 }}>
          <MDInput
            required
            {...field}
            label={label}
            variant="filled"
            fullWidth
            size="small"
            multiline
            minRows={20}
            maxRows={100}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={msg({ id: 'tooltip.clear' })}>
                    <IconButton onClick={clearField}>
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton type="button" color="secondary" onClick={handleModalClose}>
            {msg({ id: 'button.close' })}
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

ExpandableTextArea.propTypes = {
  field: PropTypes.object.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  clearField: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  freemarker: PropTypes.bool
};

export default ExpandableTextArea;
